<template>
  <el-tree
    ref="tree"
    :data="TreeData"
    node-key="Id"
    :default-expand-all="true"
    :props="defaultProps"
    :check-on-click-node="true"
    :expand-on-click-node="false"
    @node-click="onSelect"
  >
    <span Grade="custom-tree-node" slot-scope="{ node }">
      <span :Grade="{'current-node':node.isCurrent}">{{ node.label }}</span>
    </span>
  </el-tree>
</template>
<script>
import api from "@/api/st/studentclass";
export default {
  components: {},
  data() {
    return {
      TreeData: [],
      defaultProps: {
        children: "children",
        label: "Name",
      },
      nowId: null,
      visible: false,
      menu: {
        top: 0,
        left: 0,
        selectedTag: {},
      },
      // api: require("@/api/ed/Grade").default,
      api,
    };
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  mounted() {
    // this.getData()
  },
  methods: {
    getData(id) {
      api.getGradeClasses(id).then((res) => {
        this.TreeData = [];
        res.Data.forEach((i) => {
          var classes = i.Classes;
          var grade = { Id: i.GradeId, Name: i.Grade, children: [] };
          // console.log(i,i.Classes)
          grade.children = classes.map((x) => {
            return { Id: x.ClassId, Name: x.ClassName, Pid: grade.Id };
          });
          this.TreeData.push(grade);
        });
        // console.log(this.TreeData)
      });
    },
    resetSelect() {
      this.$refs.tree.setCurrentKey(null);
    },
    onSelect(data) {
      if (data.children != undefined) {
        // this.nowId = data.GradeId;
        this.$emit("on-select", { ...data, Type: 0 });
      } else {
        this.nowId = data.id;
        this.$emit("on-select", { ...data, Type: 1 });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  line-height: 40px;
  padding-right: 8px;
}
.el-button {
  font-size: 18px;
}
.current-node {
  color: #409eff;
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
    &:hover {
      background: #eee;
    }
  }
}
/deep/ .el-tree-node__children {
  /deep/ .el-tree-node {
    height: 30px;
  }
}
/deep/ .is-current {
  color: #409eff;
}
/deep/ .el-tree-node__content {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
}
</style>